<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 13V12H13V13H3ZM3 11L1 5L4.5 7.5L8 3L11.5 7.5L15 5L13 11H3Z"
      fill="currentColor"
    />
  </svg>
</template>
